import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const EllipseIcon: React.FC<IconProps> = props => {
  return (
    <BaseIcon {...props} viewBox="0 0 5 5">
      <circle cx="2.5" cy="2.5" r="2.5" />
    </BaseIcon>
  );
};
